




























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Emit, Prop, PropSync } from 'vue-property-decorator'
import { ContentConvertDocxToHtmlUseCase } from '@/modules/content/use-cases/content-convert-docx-to-html.use-case'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import ContentEditorUploader from '@/modules/content/components/shared/ContentEditorUploader.vue'
import TinyMceEditor from '@/modules/common/editor/components/shared/TinyMceEditor.vue'

@Component({
  components: {
    TinyMceEditor,
    BaseInput,
    ContentEditorUploader
  }
})
export default class ContentEditor extends Vue {
  constructor(
    private readonly fileConvertUseCase: ContentConvertDocxToHtmlUseCase
  ) {
    super()
  }

  @PropSync('content') contentSync!: string
  @PropSync('title') titleSync!: string
  @Prop({ default: () => ({}) }) editorConfig!: object

  wordFile: File | null = null

  get showUploader() {
    return this.fileConvertUseCase.isLoading || this.contentSync === ''
  }

  @Emit()
  private words(value: number) {
    return value
  }

  uploadWord() {
    if (!this.wordFile) return
    this.fileConvertUseCase.execute(this.wordFile)
      .then(remoteData => {
        const response = remoteData.unwrap().data
        this.contentSync = response.content
        //console.log(response.content)
        this.titleSync = response.title
      }).finally(() => {
      this.wordFile = null
    })
  }

}
